<template>
  <ModalVue :modalActive="isOpen" @close="close" has-header-border maxWidth="max-w-[1100px]">
    <template #header>
      <p class="font-bold text-start text-xl">Tentativas de check</p>
      <p
        v-if="meta"
        class="text-start text-sm text-gray-500 mt-0.5"
        data-testid="check-attempts-modal-subtitle"
      >
        Plantão #{{ meta.stationId }} · {{ meta.date }} {{ meta.hours }} · {{ meta.doctorName }} ·
        {{ meta.schedule }}
      </p>
    </template>
    <CheckAttemptsPanel
      v-if="isOpen && meta"
      :key="meta.stationId"
      :source="{ stationId: meta.stationId }"
      compact
    />
  </ModalVue>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import CheckAttemptsPanel from '@/components/CheckAttempts/CheckAttemptsPanel.vue'
import {
  EModals,
  useModalStore,
  type checkAttemptsModalDataType
} from '@/pinia-store/useModalStore'

const modalStore = useModalStore()
const isOpen = computed(() => modalStore.modals[EModals.CHECK_ATTEMPTS])
const meta = computed(() =>
  isOpen.value ? (modalStore.metadata as checkAttemptsModalDataType | undefined) : undefined
)

function close() {
  modalStore.toggleModal(EModals.CHECK_ATTEMPTS)
}
</script>
